import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { AppConfig } from "../../../../app.config" 

import {GlobalCompanyService} from "../global-company.service"
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FuseAlertService } from '@fuse/components/alert';


@Component({
  standalone:true,
  selector: 'global-select-company',
  imports:[ReactiveFormsModule,MatIconModule,MatToolbarModule,CommonModule,MatCheckboxModule,MatButtonModule,MatDialogModule],
  templateUrl: './setfavouritecompany.component.html',
  styleUrls: ['./setfavouritecompany.component.scss'], providers: [GlobalCompanyService] 
})
export class SetFavouriteCompanyComponent implements  OnDestroy {
  frmSetFavourite: FormGroup;

  assignedCompanyList:any[];

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {Renderer2} _renderer
   * @param {CookieService} _cookieService
   * @param {FuseMatchMediaService} _fuseMatchMediaService
   * @param {FuseNavigationService} _fuseNavigationService
   * @param {ObservableMedia} _observableMedia
   */
  constructor(
    private globalCompanyService:GlobalCompanyService,
    private readonly appConfig: AppConfig,
    private formBuilder: FormBuilder,
    public fuseAlertService: FuseAlertService,
    public matDialogRef: MatDialogRef<SetFavouriteCompanyComponent>,
  ) {  
 
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    this.frmSetFavourite=this.createForm();
    this.initDropDownData();
    
  }

 
  createForm(): FormGroup {
    return new FormGroup({
      favouriteCompany: this.formBuilder.array([])
    });
  }

  onChangeCompany(event: any) {
    const selectedCompany = <FormArray>this.frmSetFavourite.get('favouriteCompany') as FormArray;

    if (event.checked) {
      selectedCompany.push(new FormControl(event.source.value));
    } else {
      const i = selectedCompany.controls.findIndex(x => x.value.companyId === event.source.value.companyId);
      selectedCompany.removeAt(i);
    }
  }

  initDropDownData() {
    this.globalCompanyService.getAssignedCompanyToUser().subscribe(res => {
      if (res.status === 1) {    
        //this.fuseAlertService.show(res.message, res.status); 
        this.assignedCompanyList = res.data.companyList;
        this.bindFormData(res.data.companyList);
      }
    });
  }

  bindFormData(model: any) {
    if (model.length > 0) {
      var favouriteCompany = model.filter(x => x.isFavourite === true);
       this.setSelectedCompany(favouriteCompany);
      this.frmSetFavourite.controls.favouriteCompany.setValue(favouriteCompany);
    }
  }

  setSelectedCompany(data) {
    var arrayIndex: any[] = [];
    this.assignedCompanyList.forEach((value, index) => {
      var itemIndex = data.find(x => x.companyId === value.companyId);
      if (itemIndex !== undefined && itemIndex!==null && itemIndex.isFavourite===true) {
        const selectedValue = <FormArray>this.frmSetFavourite.get('favouriteCompany') as FormArray;
        selectedValue.push(new FormControl(value));
      }
    });
    return arrayIndex;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  
}
